import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LibraryType } from '@features/library/models/library-type';
import { LibraryService } from '@features/library/services/library.service';

@Component({
  selector: 'spark-nmb-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class NmbContactUsComponent implements OnInit {
  public contactUsDocumentUrl$!: Observable<string>;
  readonly DOCUMENT_NAME = 'nmb staff directory';
  readonly FILE_NAME = 'nmb-staff-directory.pdf';

  constructor(private libraryService: LibraryService) {}

  ngOnInit(): void {
    this.contactUsDocumentUrl$ = this.getContactUsDocumentUrl();
  }

  getContactUsDocumentUrl(): Observable<string> {
    return this.libraryService
      .search(LibraryType.Provider, this.DOCUMENT_NAME)
      .pipe(
        map((results) => {
          const contactUsDocItem = results.searchResultItems.find((item) =>
            item.url.endsWith(this.FILE_NAME)
          );
          if (contactUsDocItem) {
            return contactUsDocItem.url;
          }
          throw new Error('Contact Us document not found');
        })
      );
  }

  public onClick(contactUsDocumentUrl: string): void {
    window.open(contactUsDocumentUrl, '_blank');
  }
}
